/**
 * ONE message extraction for connector admin surfaces (INFRA-10.2 item 3):
 * server refusals arrive as `response.data.message` (typed BadRequestErrors
 * through the endpoint wrapper), plain failures as `message`. The ops-console
 * retry display and the queue mutations render through this same helper so a
 * refusal reads identically wherever it surfaces.
 */
export const connectorErrorMessage = (error: unknown, fallback: string): string => {
  const e = error as {
    response?: { data?: { message?: string } };
    message?: string;
  } | null;

  return e?.response?.data?.message || e?.message || fallback;
};
